import { createSlice } from '@reduxjs/toolkit';
import * as Types from 'types';
import { CooperatorsUserItem } from 'types';
import {
  getWorkerStatus,
  getWorkRisk,
  getCheckSlingTool,
  getListTestScaffold,
  getSafetyInstructions,
  getWorkerShift,
  //getShopSchedulesWorkersChargeSiteList,
  getCooperatorUser,
  //getSiteUserSchedules,
  getSiteGroupsWorkers,
} from './thunk';

interface InitialState {
  maxPoint: number;
  workerStatus: {
    sites: Types.WorkerStatus[];
    loading: boolean;
  };
  workRisk: {
    sites: Types.WorkRisk[];
    loading: boolean;
  };
  slingTool: {
    sites: Types.CheckSlingTool[];
    loading: boolean;
  };
  listTestScaffold: {
    sites: Types.TestScaffold[];
    loading: boolean;
  };
  safetyInstructions: {
    sites: Types.SafetyInstructions[];
    loading: boolean;
  };
  dataChart: {
    data: Types.WorkerShift[];
    loading: boolean;
  };
  tableForm: {
    data: Types.WorkUser[];
    loading: boolean;
  };
  ShopSchedulesWorkersChargeSiteList: {
    data: Types.getShopSchedulesWorkersChargeSiteListResponse | null;
    loading: boolean;
  };
  siteProp: Types.PlannedWorkLocations;
  locationDTCAgent: Types.TableDTCAgent;
  cooperatorUser: {
    cooperators: CooperatorsUserItem[];
    loading: boolean;
  };
  siteUserSchedules: {
    users: Types.SiteUserSchedulesUsersItem[] | null;
    loading: boolean;
  };
  siteGroupsWorkers: {
    users: Types.UsersType[] | null;
    loading: boolean;
  };
}

const initialState: InitialState = {
  maxPoint: 0,
  workerStatus: {
    sites: [],
    loading: true,
  },
  workRisk: {
    sites: [],
    loading: true,
  },
  slingTool: {
    sites: [],
    loading: true,
  },
  listTestScaffold: {
    sites: [],
    loading: true,
  },
  safetyInstructions: {
    sites: [],
    loading: true,
  },
  dataChart: {
    data: [],
    loading: true,
  },
  tableForm: {
    data: [],
    loading: true,
  },
  siteProp: {
    id: '',
    site_name: '',
    site: '',
    start_date: '',
    end_date: '',
    worker: '',
  },
  locationDTCAgent: {
    building_code: '',
    building_id: 0,
    hyoutokukbn_name: '',
    product_name: '',
    registered_type: 0,
    site_address: '',
    site_director_name: '',
    site_latitude: 0,
    site_longitude: 0,
    site_name: '',
    user_id: 0,
  },
  ShopSchedulesWorkersChargeSiteList: {
    data: null,
    loading: false,
  },
  cooperatorUser: {
    cooperators: [],
    loading: false,
  },
  siteUserSchedules: {
    users: null,
    loading: false,
  },
  siteGroupsWorkers: {
    users: null,
    loading: false,
  },
};

export const businessDetailSlice = createSlice({
  name: 'businessDetail-page',
  initialState,
  reducers: {
    setDataWorkerStatus(state, { payload }) {
      const index = state.workerStatus.sites.findIndex((obj) => obj.id === payload.id);
      state.workerStatus.sites[index].safety_order_check_status = 2;
    },
    setMaxPoint(state, { payload }) {
      state.maxPoint = payload;
    },
    setSiteProps(state, { payload }) {
      if (payload) {
        state.siteProp = payload.state;
      }
    },
    setLocationDTCAgent(state, { payload }) {
      if (payload) {
        state.locationDTCAgent = payload.state;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getWorkerStatus.pending, (state) => {
      state.workerStatus.loading = true;
    });
    builder.addCase(getWorkerStatus.rejected, (state) => {
      state.workerStatus.sites = initialState.workerStatus.sites;
      state.workerStatus.loading = false;
    });
    builder.addCase(getWorkerStatus.fulfilled, (state, { payload }) => {
      state.workerStatus = { sites: payload.sites, loading: false };
    });

    builder.addCase(getWorkRisk.pending, (state) => {
      state.workRisk.loading = true;
    });
    builder.addCase(getWorkRisk.rejected, (state) => {
      state.workRisk.sites = initialState.workRisk.sites;
      state.workRisk.loading = false;
    });
    builder.addCase(getWorkRisk.fulfilled, (state, { payload }) => {
      state.workRisk = { sites: payload.sites, loading: false };
    });

    builder.addCase(getCheckSlingTool.pending, (state) => {
      state.slingTool.loading = true;
    });
    builder.addCase(getCheckSlingTool.rejected, (state) => {
      state.slingTool.sites = initialState.slingTool.sites;
      state.slingTool.loading = false;
    });
    builder.addCase(getCheckSlingTool.fulfilled, (state, { payload }) => {
      state.slingTool = { sites: payload.sites, loading: false };
    });

    builder.addCase(getListTestScaffold.pending, (state) => {
      state.listTestScaffold.loading = true;
    });
    builder.addCase(getListTestScaffold.rejected, (state) => {
      state.listTestScaffold.sites = initialState.listTestScaffold.sites;
      state.listTestScaffold.loading = false;
    });
    builder.addCase(getListTestScaffold.fulfilled, (state, { payload }) => {
      state.listTestScaffold = { sites: payload.sites, loading: false };
    });

    builder.addCase(getSafetyInstructions.pending, (state) => {
      state.safetyInstructions.loading = true;
    });
    builder.addCase(getSafetyInstructions.fulfilled, (state, { payload }) => {
      state.safetyInstructions = { sites: payload.sites, loading: false };
    });
    builder.addCase(getSafetyInstructions.rejected, (state) => {
      state.safetyInstructions.sites = initialState.safetyInstructions.sites;
      state.safetyInstructions.loading = false;
    });

    builder.addCase(getWorkerShift.pending, (state) => {
      state.dataChart.loading = true;
    });
    builder.addCase(getWorkerShift.fulfilled, (state, { payload }) => {
      state.dataChart.data = payload.data;
      state.dataChart.loading = false;
    });
    builder.addCase(getWorkerShift.rejected, (state) => {
      state.dataChart.data = initialState.dataChart.data;
      state.dataChart.loading = false;
    });

    // 2023/12/29 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 start
    // ShopSchedulesWorkersChargeSiteList
    // builder.addCase(getShopSchedulesWorkersChargeSiteList.pending, (state) => {
    //   state.ShopSchedulesWorkersChargeSiteList.loading = true;
    //   state.ShopSchedulesWorkersChargeSiteList.data = null;
    // });
    // builder.addCase(getShopSchedulesWorkersChargeSiteList.fulfilled, (state, { payload }) => {
    //   state.ShopSchedulesWorkersChargeSiteList.data = payload;
    //   state.ShopSchedulesWorkersChargeSiteList.loading = false;
    // });
    // builder.addCase(getShopSchedulesWorkersChargeSiteList.rejected, (state) => {
    //   state.ShopSchedulesWorkersChargeSiteList.data =
    //     initialState.ShopSchedulesWorkersChargeSiteList.data;
    //   state.ShopSchedulesWorkersChargeSiteList.loading = false;
    // });
    // 2023/12/29 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 end

    //cooperatorUser
    builder.addCase(getCooperatorUser.pending, (state) => {
      state.cooperatorUser.loading = true;
      state.cooperatorUser.cooperators = [];
    });
    builder.addCase(getCooperatorUser.fulfilled, (state, { payload }) => {
      state.cooperatorUser.cooperators = payload.cooperators;
      state.cooperatorUser.loading = false;
    });
    builder.addCase(getCooperatorUser.rejected, (state) => {
      // state.cooperatorUser.cooperators = initialState.cooperatorUser.cooperators;
      state.cooperatorUser.loading = false;
    });

    // 2023/12/29 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 start
    //siteUserSchedules
    // builder.addCase(getSiteUserSchedules.pending, (state) => {
    //   state.siteUserSchedules.users = [];
    //   state.siteUserSchedules.loading = true;
    // });
    // builder.addCase(getSiteUserSchedules.fulfilled, (state, { payload }) => {
    //   state.siteUserSchedules.users = payload.users;
    //   state.siteUserSchedules.loading = false;
    // });
    // builder.addCase(getSiteUserSchedules.rejected, (state) => {
    //   state.siteUserSchedules.users = initialState.siteUserSchedules.users;
    //   state.siteUserSchedules.loading = false;
    // });
    // 2023/12/29 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 end
    // 2023/12/29 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 start
    builder.addCase(getSiteGroupsWorkers.pending, (state) => {
      state.siteGroupsWorkers.loading = true;
    });

    builder.addCase(getSiteGroupsWorkers.fulfilled, (state, { payload }) => {
      state.siteGroupsWorkers.users = payload.users;
      state.siteGroupsWorkers.loading = false;
    });
    builder.addCase(getSiteGroupsWorkers.rejected, (state) => {
      state.siteGroupsWorkers.users = initialState.siteGroupsWorkers.users;
      state.siteGroupsWorkers.loading = false;
    });
    // 2023/12/29 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 end
  },
});

export const { setLocationDTCAgent } = businessDetailSlice.actions;

export default businessDetailSlice.reducer;
